import { gql } from "@apollo/client";

export default gql`
  mutation removeTeamsIntegrationMutation($organizationId: Int!) {
    removeTeamsIntegration(organizationId: $organizationId) {
      organization {
        id
        hasTeamsTranscriptConnection
        hasTeamsInstallation
      }
    }
  }
`;
